<template>
    <div>
        <div v-if="hasError" class="error-fallback">
            <v-alert
                type="error"
                dismissible
                @input="hasError = false"
                class="mb-4"
            >
                <v-row align="center">
                    <v-col class="grow">
                        <div class="title">
                            {{ title || 'Something went wrong' }}
                        </div>
                        <div v-if="message">{{ message }}</div>
                    </v-col>
                    <v-col class="shrink">
                        <v-btn
                            small
                            color="white"
                            class="ml-2"
                            @click="retry"
                            :loading="retrying"
                        >
                            <v-icon small left>mdi-refresh</v-icon>
                            Retry
                        </v-btn>
                    </v-col>
                </v-row>
            </v-alert>
        </div>
        <slot v-else :retry="retry"></slot>
    </div>
</template>

<script>
import { captureException, addBreadcrumb } from '@/config/sentry.config'

export default {
    name: 'ErrorFallback',
    props: {
        title: {
            type: String,
            default: '',
        },
        message: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            hasError: false,
            retrying: false,
        }
    },
    errorCaptured(err, instance, info) {
        this.hasError = true

        // Add breadcrumb
        addBreadcrumb(
            `Error in ${this.$options.name} component`,
            'error',
            'error'
        )

        // Send to Sentry
        captureException(err, {
            errorFallback: {
                componentName: this.$options.name,
                componentInfo: info,
                route: this.$route ? this.$route.path : 'unknown',
            },
        })

        return false
    },
    methods: {
        retry() {
            this.retrying = true
            this.hasError = false

            setTimeout(() => {
                this.retrying = false
                this.$forceUpdate()
            }, 500)
        },
    },
}
</script>

<style scoped>
.error-fallback {
    margin: 16px 0;
}
</style>
